var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFc30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15,1.5c7.44,0,13.5,6.06,13.5,13.5s-6.06,13.5-13.5,13.5S1.5,22.44,1.5,15,7.56,1.5,15,1.5m0-1.5C6.72,0,0,6.72,0,15s6.72,15,15,15,15-6.72,15-15S23.28,0,15,0h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12,10.62h-5.75v-3.75h17.5v3.75h-5.74v12.51h-6.01v-12.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFc30);
export default __webpack_public_path__ + "static/media/FC30.aea5c9ad59fce63a06831d707d6df34b.svg";
export { ForwardRef as ReactComponent };